<template>
  <div class="form-validator-feedback">
    <b-form-invalid-feedback :state="form.$dirty ? !form.$error : null">
      <div v-if="form.$params.required && !form.required">必須です</div>
      <div v-if="form.$params.email && !form.email">メールアドレス形式で入力してください</div>
      <div v-if="form.$params.decimal && !form.decimal">数値を入力してください</div>
      <div v-if="form.$params.integer && !form.integer">整数を入力してください</div>
      <div v-if="form.$params.sameAs && !form.sameAs">入力が一致しません</div>

      <div v-if="form.$params.minLength && form.$params.maxLength">
        <div v-if="!form.minLength || !form.maxLength">{{ form.$params.minLength.min }}～{{ form.$params.maxLength.max }}文字で入力してください</div>
      </div>
      <div v-else>
        <div v-if="form.$params.minLength && !form.minLength">{{ form.$params.minLength.min }}文字以上で入力してください</div>
        <div v-if="form.$params.maxLength && !form.maxLength">{{ form.$params.maxLength.max }}文字以内で入力してください</div>
      </div>

      <div v-if="form.$params.checked && !form.checked">チェックを入れてください</div>
    </b-form-invalid-feedback>
  </div>
</template>

<script>
export default {
  name: 'FormValidatorFeedback',
  props: [ 'form', 'name' ],
};
</script>

<style scoped>
</style>